import React, { Component } from 'react';

class UseWindowSize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
    };
    window.addEventListener('resize', this.changeWindowSize);
  }

  componentDidMount = () => {
    this.changeWindowSize();
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.changeWindowSize);
  };

  changeWindowSize = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  render() {
    return (
      <>
        {React.cloneElement(this.props.children, {
          height: this.state.height,
          width: this.state.width,
        })}
      </>
    );
  }
}

export default UseWindowSize;
